import { LeadStatus } from './../../core/constants/leadStatus';
import { CommonModule } from '@angular/common';
import { LeadService } from './../../features/leads/services/lead.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PreferenceCodeService } from '../../features/preference-code/services/preference-code.service';

@Component({
  selector: 'app-lead-new',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './lead-new.component.html',
  styleUrl: './lead-new.component.scss',
})
export class LeadNewComponent {
  search: any;
  assignedTo: any;
  status: any;
  chartAccounts: any;
  createLeadForm: FormGroup;
  leadInput: any;
  leadId:any;
  selectedBranchId: any;
  leadData:any;
  leadCode: any;

  constructor(
    private leadService: LeadService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private preferenceService: PreferenceCodeService
  ) {}

  ngOnInit() {
    this.createLeadForm = this.fb.group({
      leadName: ['', Validators.required],
      leadCode: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\+?\d{10,15}$/)]],
      source: ['', [Validators.required]],
      industry: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      expectedValue: [
        '',
        [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/)],
      ],
      expectedCloseDate: ['', [Validators.required,this.todayOrFutureDateValidator()]],
      notes: ['', [Validators.required]],
      probability: ['', [Validators.required, this.numericValidator(0, 100)]],
    });

    this.selectedBranchId = localStorage.getItem('selectedBranchId');

    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.leadId = +id;        
        this.loadJournalData();
      }
    });
    if(!this.leadId){
      this.preferenceCode();
    }
  }

  preferenceCode(search: string = '') {
    this.preferenceService.fetchPreferenceCodes(search, 'Lead').subscribe({
      next: (response) => {
        console.log("response",response);
        
        response.forEach((prefix: any) => {
          this.leadCode = prefix?.sequenceCode;
        });
        this.createLeadForm.patchValue({ leadCode: this.leadCode });
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }

  onSave() {
    if (this.createLeadForm.invalid) {
      this.createLeadForm.markAllAsTouched();
      return;
    }
    const formValue = this.createLeadForm.value;

    this.leadInput = {
      ...formValue,
      branchID: Number(this.selectedBranchId),
      expectedValue:parseFloat(formValue.expectedValue),
      probability:Number(formValue.probability),
      status: 'New',
    };

    const updatedLeadInput={
      ...this.leadInput,
      id:this.leadId,
      // assignedTo: this.leadData?.assignedTo,
      status: this.leadData?.status
  }
    // console.log(this.leadInput);
    if(this.leadId){      
      this.leadService.updateLead(this.leadId, updatedLeadInput).subscribe({
        next: (data) => {
          if (data) {
            this.createLeadForm.reset();
            this.toastr.success('Lead updated successfully', 'Success');
            this.router.navigate(['/leads']);
          }
        },
        error: (error) => {
          this.toastr.error(error?.message, 'Error');
        },
      })
    }else{
      this.leadService.createLead(this.leadInput).subscribe({
        next: (data) => {
          if (data) {
            this.createLeadForm.reset();
            this.toastr.success('Lead created successfully', 'Success');
            this.router.navigate(['/leads']);
          }
        },
        error: (error) => {
          this.toastr.error(error?.message, 'Error');
        },
      });
    }
  }

  private loadJournalData(): void {
    if (this.leadId !== null) {
      this.leadService.fetchLeadById(this.leadId).subscribe({

        next: (data) => {
          this.leadData = data;
          console.log("journalEntry",this.leadData);
                
          this.populateForm();
        },
        error: (error) => console.error(error),
      });
    } else {
      console.warn('Journal ID is null; cannot load journal data.');
    }
  }

  numericValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = Number(control.value);
      if (isNaN(value)) {
        return { numbersOnly: true };
      }
      if (value < min) {
        return { min: { min, actual: value } };
      }
      if (value > max) {
        return { max: { max, actual: value } };
      }
      return null;
    };
  }
  todayOrFutureDateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const selectedDate = new Date(control.value);
      const today = new Date();

      // Remove time from comparison
      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        return { pastDate: true };
      }

      return null; // ✅ valid
    };
  }

  private populateForm(): void {
    this.createLeadForm.patchValue({
      id: this.leadData.id,
      leadName: this.leadData.leadName,
      email: this.leadData.email,
      phone: this.leadData.phone,
      source: this.leadData.source,
      industry: this.leadData.industry,
      companyName: this.leadData.companyName,
      expectedValue: this.leadData.expectedValue,
      expectedCloseDate: new Date(Number(this.leadData.expectedCloseDate)),
      notes:this.leadData.notes,
      probability: this.leadData.probability,
    });
  }

  onCancel() {
    this.createLeadForm.reset();
  }
}
